// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"f47b8677","200":"4e4417ab","234":"dff9906f","326":"e9ea5c0d","446":"2afaaed0","459":"526dabd9","516":"aad90c75","855":"d77436ab","922":"5b28ec25"}[chunkId] + ".chunk.js";
};